import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query'
import { getCreditCards } from 'src/queries/creditCard.network'
import { GetCreditCardsRequest } from 'src/requests/getCreditCards.request'

const creditCardListQueryKeys = {
  list: (currentUserId: string | undefined, filters: GetCreditCardsRequest) =>
    ['credit-card-lists', currentUserId, filters] as const,
}

export const normalizeCreditCardListFilters = (
  filters: GetCreditCardsRequest,
): GetCreditCardsRequest => {
  const { page: _page, search, ...rest } = filters
  const normalizedSearch = search?.trim()

  return {
    ...rest,
    ...(normalizedSearch ? { search: normalizedSearch } : {}),
  }
}

export const creditCardListQueries = {
  list: (currentUserId: string | undefined, filters: GetCreditCardsRequest) => {
    const normalizedFilters = normalizeCreditCardListFilters(filters)

    return infiniteQueryOptions({
      queryKey: creditCardListQueryKeys.list(currentUserId, normalizedFilters),
      queryFn: ({ pageParam }) => {
        if (!currentUserId) {
          throw new Error(
            'creditCardListQueries.list: currentUserId is required',
          )
        }
        return getCreditCards(normalizedFilters, pageParam)
      },
      enabled: Boolean(currentUserId),
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { numberOfPages, page } = lastPage.pagination
        return page < numberOfPages - 1 ? page + 1 : undefined
      },
      placeholderData: keepPreviousData,
      gcTime: 0,
    })
  },
}
